import request from '../../utils/request'

const pre="/system/sysRole";


export const reqListRole = (data) => {
    return request({
        url: pre+'/page',
        method: 'POST',
        data: data
    })
}
export const reqListAllRole = (data) => {
    return request({
        url: pre+'/list',
        method: 'get',
    })
}
export const reqInsertRole = (data) => {
    return request({
        url: pre+'/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateRole = (data) => {
    return request({
        url: pre+'/update',
        method: 'POST',
        data: data
    })
}

export const reqDeleteRole = (id) => {
    return request({
        url: pre+'/delete?id='+id,
        method: 'get'
    })
}
export const reqGetMenuListByRoleId = (id) => {
    return request({
        url: pre+'/getMenuListByRoleId?roleId='+id,
        method: 'get'
    })
}
export const reqRoleAuthMenu = (data) => {
    return request({
        url: pre+'/authMenu',
        method: 'post',
        data
    })
}

// ===== 兼容旧调用名（供 index12.vue / Users.vue 引用）=====
export const listRoles = reqListAllRole
export const deleteRole = reqDeleteRole
export const getRoleById = (id) => {
    return request({
        url: pre + '/detail?id=' + id,
        method: 'get'
    })
}
export const saveRole = (data) => {
    return data && data.id ? reqUpdateRole(data) : reqInsertRole(data)
}


